var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcoLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.9974 51.3333C40.884 51.3333 51.3307 40.8866 51.3307 28C51.3307 15.1133 40.884 4.66666 27.9974 4.66666C15.1108 4.66666 4.66406 15.1133 4.66406 28C4.66406 40.8866 15.1108 51.3333 27.9974 51.3333Z",
    fill: "#065FA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9974 51.3333C40.884 51.3333 51.3307 40.8866 51.3307 28C51.3307 15.1133 40.884 4.66666 27.9974 4.66666C15.1108 4.66666 4.66406 15.1133 4.66406 28C4.66406 40.8866 15.1108 51.3333 27.9974 51.3333Z",
    stroke: "#065FA6",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3359 21C23.3359 18.4227 25.4252 16.3333 28.0026 16.3333C30.58 16.3333 32.6693 18.4227 32.6693 21C32.6693 21.929 32.3979 22.7946 31.9298 23.5219C30.5352 25.6893 28.0026 27.7559 28.0026 30.3333V31.5",
    stroke: "#065FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 39.6667H28.0054",
    stroke: "#065FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcoLarge);
export default __webpack_public_path__ + "static/media/supportIcoLarge.2d5333bc3a64d6f3557383e36af3180d.svg";
export { ForwardRef as ReactComponent };